<template>
  <v-container fluid class="gradient">
    <v-row
      align="center"
      justify="center"
      :class="$vuetify.breakpoint.mdAndUp ? 'full-height px-12' : 'px-12'"
    >
      <v-col cols="12" md="6" class="pl-12">
        <h1 class="white--text pb-4">ATENCIÓN Y SEGUIMIENTO A TRABAJADORES</h1>
        <p class="white--text text-justify">
          En Universidad Vizcaya de las Américas nos interesa que tengas
          comodidad y seguridad en el puesto que desempenas, por tanto ponemos a
          tu disposición los siguientes medios de comunicación, donde te
          brindaremos un acompañamiento en caso de que así lo requieras.
          <br />
          <br />
          <strong>1. ¿Cuándo te puedes comunicar con nosotros?:</strong>
        </p>
        <p class="white--text text-justify ml-8">
          a. Si tienes una duda u observación de algo referente a tu puesto y
          actividades.<br />
          b. Si tienes alguna inconformidad que no haya sido escuchada y
          atendida dentro de tu campus.
        </p>
        <p class="white--text text-justify">
          <strong
            >2. Una vez que te comuniques, se te brindará una respuesta en un
            lapso de tiempo no mayor 72 horas.</strong
          >
        </p>
        <p class="white--text text-justify">
          Ten la seguridad de que la información que nos compartas tendrá un
          seguimiento que te permitira tener una resolución objetiva a tu
          situación.<br />
          <br />
          <br />
          Si estas interesado en formar parte de la familia Vizcaya accede a
          nuestra <span style="color: #8e0d2c"> bolsa de trabajo</span> y sube
          tu Curriculum Vitae.
        </p>
      </v-col>
      <v-col cols="12" md="6" class="pl-7 pr-12">
        <v-form v-model="valid" ref="form">
          <v-row>
            <v-col cols="12" md="6" class="mb-0 pb-0">
              <p class="white--text mb-0">Nombre *</p>
              <v-text-field
                label="Nombre(s) del colaborador"
                outlined
                class="white-outline pa-0"
                v-model="name"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" class="mb-0 pb-0">
              <p class="white--text my-0">Apellido *</p>
              <v-text-field
                label="Apellido(s) del colaborador"
                outlined
                class="white-outline"
                v-model="lastname"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" class="mt-0 pt-0 pb-0">
              <p class="white--text mb-0">Puesto que desempeña *</p>
              <v-text-field
                label="Ej. Docente"
                v-model="puesto"
                outlined
                class="white-outline"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0 py-0">
              <p class="white--text mb-0">Correo institucional o personal *</p>
              <v-text-field
                label="correo@uva.edu.mx"
                outlined
                v-model="email"
                class="white-outline"
                :rules="[rules.required, rules.email]"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0 py-0">
              <p class="white--text mb-0">Teléfono *</p>
              <v-text-field
                outlined
                class="white-outline my-0"
                v-model="phone"
                label="Teléfono"
                :rules="[rules.required, rules.phone]"
              />
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <p class="white--text my-0 pt-0">Duda y/o sugerencia</p>
              <v-textarea
                label=""
                hide-details=""
                outlined
                v-model="question"
                class="white-outline white-textarea mb-2"
              />
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <p class="white--text my-0 pt-0">
                Subir identificación de trabajador (Por ambos lados) *
              </p>
            </v-col>
            <v-col cols="12" md="6" class="my-0 py-0">
              <v-btn block small color="white" class="mt-2" @click="pickFile">
                Elegir archivos</v-btn
              >
            </v-col>
            <v-col cols="12" md="6" class="my-0 py-0">
              <p class="white--text pt-2" v-if="selectedFilesCount > 0">
                Has seleccionado {{ selectedFilesCount }} archivo(s).
              </p>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/*,application/pdf"
                @change="onPhotographyPicked"
              />
            </v-col>
            <v-col cols="12" class="mt-5 py-0 text-center">
              <v-btn
                class="primary white--text"
                :disabled="!valid"
                large
                rounded
                @click="sendInfo"
                :loading="loading"
                >Enviar</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
      {{ msg }}
      <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  data: () => ({
    name: null,
    lastname: null,
    puesto: null,
    email: null,
    phone: null,
    question: null,
    loading: false,
    snackbar: false,
    msg: "",
    color: "",
    imageName: "",
    imageUrl: "",
    img_doc: "",
    selectedFilesCount: 0,
    valid: false,
    rules: {
      required: (v) => !!v || "Este campo es obligatorio",
      email: (v) => /.+@.+\..+/.test(v) || "Correo inválido",
      phone: value =>
        /^[0-9]{7,10}$/.test(value) || 'Debe contener entre 7 y 10 dígitos numéricos',
    },
  }),
  methods: {
    pickFile() {
      this.$refs.image.click(); // activa el input file oculto
    },
    onPhotographyPicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.img_doc = files[0]; // this is an image file that can be sent to server...
        });
        this.selectedFilesCount = files.length;
      } else {
        this.imageName = "";
        this.imageUrl = "";
        this.selectedFilesCount = 0;
      }
    },
    sendInfo() {
      if (!this.$refs.form.validate()) {
        return;
      } else if (this.selectedFilesCount <= 0) {
        this.loading = false;
        this.msg = "Favor de subir su identificación de trabajador";
        this.color = "warning";
        this.snackbar = true;
      } else {
        this.loading = true;
        if (
          this.name != null &&
          this.lastname != null &&
          this.puesto != null &&
          this.email != null &&
          this.phone != null 
        ) {
          let formData = new FormData();
          formData.append("name", this.name);
          formData.append("lastname", this.lastname);
          formData.append("puesto", this.puesto);
          formData.append("email", this.email);
          formData.append("question", this.question);
          formData.append("phone", this.phone);
          formData.append("file", this.img_doc);

          axios({
            method: "post",
            url: "https://adminuva.tidingo.com/api/send-email-collaborator",
            data: formData,
            config: {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          }).then((response) => {
            if (response.data.status == "200") {
              this.$refs.form.reset();  
              this.msg =
                "Mensaje enviado, pronto estaremos en contacto contigo.";
              this.color = "success";
              this.snackbar = true;
              this.name = null;
              this.lastname = null;
              this.puesto = null;
              this.email = null;
              this.question = null;
              this.img_doc = "";
              this.selectedFilesCount = 0;
            } else {
              this.msg =
                "Revise que la información solicitada este cargada correctamente.";
              this.color = "error";
              this.snackbar = true;
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
          this.msg = "Complete todos los datos";
          this.color = "warning";
          this.snackbar = true;
        }
      }
    },
  },
};
</script>
<style scoped>
.gradient {
  background: #000;
  background: linear-gradient(
    95deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(79, 20, 51, 1) 90%,
    rgba(79, 20, 51, 1) 100%
  );
}

.full-height {
  height: 100vh;
  padding: 0;
}

.white-outline ::v-deep fieldset {
  border: 1px solid white !important;
}

.white-outline ::v-deep .v-label {
  color: white !important;
}

.white-outline ::v-deep input {
  color: white !important;
}

.white-textarea >>> textarea {
  color: white !important;
}

::v-deep(.v-textarea textarea) {
  color: white !important;
}
</style>
